export default {"src":"/_next/static/media/breadcrumbArrow.5ac03523.svg","height":8,"width":5};